import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'

type Overlay = 'menu' | 'chat' | 'cookies' | 'news' | null
const OverlayContext = createContext<{
  active: Overlay
  open: (overlay: Exclude<Overlay, null>) => void
  close: () => void
  closeNavigationPanels: () => void
} | null>(null)

/** Every primary panel, including future news dialogs, uses this single owner. */
export function OverlayProvider({ children }: { children: ReactNode }) {
  const [active, setActive] = useState<Overlay>(null)
  const close = useCallback(() => setActive(null), [])
  const closeNavigationPanels = useCallback(() => setActive(current => current === 'news' ? current : null), [])
  return <OverlayContext.Provider value={{ active, open: setActive, close, closeNavigationPanels }}>{children}</OverlayContext.Provider>
}
export function useOverlay() {
  const context = useContext(OverlayContext)
  if (!context) throw new Error('OverlayProvider is required')
  return context
}
